// extracted by mini-css-extract-plugin
export default {"container":"TextAlignInput_container__EXv4u","button__container":"TextAlignInput_button__container__htg9t","active":"TextAlignInput_active__Nb6Jd"};